module.exports = __webpack_public_path__ + "static/media/ic_unlock.a5654cfa.svg";